// extracted by mini-css-extract-plugin
module.exports = {"back_arrow":"_21620d3522--back_arrow--HSCEm"};